import ActionTypeZona from "../ActionTypeZona";
// import {ModosOp} from '../../../../_comun/reductores/Constantes'
import { TipoZona, Udm} from "../../../../isp.žapi.zonas/constantesApiZonas";

export default class CargaDeZonaConsultado extends ActionTypeZona {

    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.domain.idCliente = this.payload.idCliente;
        // nuevoEstado.domain.fechaReg = this.payload.fechaReg;
        // nuevoEstado.domain.estado = this.payload.estado;
        // nuevoEstado.flag.procesandoComando = false;
        // nuevoEstado.flag.modoOperacion = ModosOp.OK;
        // Estado.Registrado = estado.domain;
        // Estado.ParaUpdate={};
        nuevoEstado.flag.modal = false;
        nuevoEstado.flag.cargandoEntidad = false;
        nuevoEstado.domain.screen = {...estado.domain.screen, ...this.payload};
        nuevoEstado.domain.screen.combos.tiposZona=[nuevoEstado.domain.screen.tipoZona]
        if (this.payload.tipoZona === TipoZona.ServiciosGen || this.payload.tipoZona === TipoZona.Articulo) {
            // nuevoEstado.domain.screen.udm=Udm.Unidad;
            
            nuevoEstado.domain.screen.combos.udms=[Udm.Unidad];
        }
        if (this.payload.tipoZona === TipoZona.PlanInternet) {
            // nuevoEstado.domain.screen.udm=Udm.Mensual;
            // nuevoEstado.domain.screen.combos.tiposZona=[nuevoEstado.domain.screen.tipoZona]
            nuevoEstado.domain.screen.combos.udms=[Udm.Mensual];
        }

        nuevoEstado.domain.cargado = JSON.parse(JSON.stringify(this.payload));
        nuevoEstado.domain.update = {}
        nuevoEstado.domain.nroUpdates= 0;

        return nuevoEstado;
    }

}